import React from 'react';
import { formatTurkishCurrency } from '../utils/formatters';
import { styles } from '../constants/styles';
import ArsivArama from './ArsivArama';

const ArsivSistemi = ({ kumbaralar, acilmisKumbaralar = [] }) => {
  return (
    <div style={styles.section}>
      <h2 style={{fontSize: '20px', fontWeight: 'bold', marginBottom: '20px'}}>📦 Kumbara Arşiv Sistemi</h2>

      {/* Arşiv İstatistikleri */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '20px'}}>
        <div style={{background: '#ebf8ff', padding: '15px', borderRadius: '10px', border: '2px solid #4299e1'}}>
          <div style={{fontSize: '14px', color: '#2c5282', marginBottom: '5px'}}>Toplam Arşiv ID</div>
          <div style={{fontSize: '24px', fontWeight: 'bold', color: '#2c5282'}}>
            {kumbaralar.reduce((sum, k) => sum + (k.arsiv?.length || 0), 0)}
          </div>
        </div>
        <div style={{background: '#f0fff4', padding: '15px', borderRadius: '10px', border: '2px solid #48bb78'}}>
          <div style={{fontSize: '14px', color: '#22543d', marginBottom: '5px'}}>Arşivli Kumbara</div>
          <div style={{fontSize: '24px', fontWeight: 'bold', color: '#22543d'}}>
            {kumbaralar.filter(k => k.arsiv && k.arsiv.length > 0).length + acilmisKumbaralar.length}
          </div>
          <div style={{fontSize: '11px', color: '#22543d', marginTop: '5px'}}>
            (Aktif: {kumbaralar.filter(k => k.arsiv && k.arsiv.length > 0).length}, Açılmış: {acilmisKumbaralar.length})
          </div>
        </div>
        <div style={{background: '#fff5f5', padding: '15px', borderRadius: '10px', border: '2px solid #fc8181'}}>
          <div style={{fontSize: '14px', color: '#c53030', marginBottom: '5px'}}>En Çok Kullanılan ID</div>
          <div style={{fontSize: '20px', fontWeight: 'bold', color: '#c53030'}}>
            {(() => {
              const idKullanim = {};
              kumbaralar.forEach(k => {
                if (k.arsiv && Array.isArray(k.arsiv)) {
                  k.arsiv.forEach(id => {
                    idKullanim[id] = (idKullanim[id] || 0) + 1;
                  });
                }
              });
              const enCokKullanilan = Object.entries(idKullanim).sort((a, b) => b[1] - a[1])[0];
              return enCokKullanilan ? `${enCokKullanilan[0]} (${enCokKullanilan[1]}x)` : '-';
            })()}
          </div>
        </div>
      </div>

      {/* V3.1: Arşiv Arama - Hem aktif hem açılmış kumbaralar */}
      <ArsivArama kumbaralar={kumbaralar} acilmisKumbaralar={acilmisKumbaralar} />

      {/* V3.1: Arşiv Listesi - Hem aktif hem açılmış kumbaralar */}
      <div style={{background: '#f7fafc', padding: '15px', borderRadius: '10px', marginBottom: '20px'}}>
        <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '15px'}}>📋 Tüm Arşiv ID'leri</h3>
        {kumbaralar.filter(k => k.arsiv && k.arsiv.length > 0).length === 0 && acilmisKumbaralar.length === 0 ? (
          <p style={{color: '#718096', textAlign: 'center', padding: '20px'}}>Henüz arşiv ID'si yok</p>
        ) : (
          <div style={{maxHeight: '500px', overflowY: 'auto'}}>
            {/* Aktif Kumbaralar */}
            {kumbaralar
              .filter(k => k.arsiv && k.arsiv.length > 0)
              .map(k => (
                <div key={k.id || k.firestoreId} style={{padding: '12px', background: 'white', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e2e8f0'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                    <div>
                      <span style={{fontWeight: 'bold', fontSize: '15px'}}>📍 {k.firmaAdi || 'Firma yok'}</span>
                      <span style={{...styles.badge, background: '#4299e1', color: 'white', marginLeft: '10px'}}>Aktif: {k.id}</span>
                    </div>
                  </div>
                  <div style={{fontSize: '12px', color: '#718096', marginBottom: '5px'}}>Adres: {k.adres || 'Adres yok'}</div>
                  <div style={{fontSize: '12px', color: '#4a5568'}}>
                    <strong>Arşiv ID'leri ({k.arsiv.length}):</strong> {k.arsiv.join(', ')}
                  </div>
                </div>
              ))}
            {/* Açılmış Kumbaralar */}
            {acilmisKumbaralar
              .filter(ak => ak.arsiv && ak.arsiv.length > 0)
              .map(ak => (
                <div key={ak.firestoreId || ak.id} style={{padding: '12px', background: '#fff5f5', borderRadius: '8px', marginBottom: '10px', border: '1px solid #fc8181'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                    <div>
                      <span style={{fontWeight: 'bold', fontSize: '15px'}}>📍 {ak.firmaAdi || 'Firma yok'}</span>
                      <span style={{...styles.badge, background: '#fc8181', color: 'white', marginLeft: '10px'}}>Açılmış: {ak.id}</span>
                    </div>
                  </div>
                  <div style={{fontSize: '12px', color: '#718096', marginBottom: '5px'}}>Adres: {ak.adres || 'Adres yok'}</div>
                  <div style={{fontSize: '12px', color: '#4a5568', marginBottom: '5px'}}>
                    <strong>Arşiv ID'leri ({ak.arsiv.length}):</strong> {ak.arsiv.join(', ')}
                  </div>
                  <div style={{fontSize: '12px', color: '#c53030'}}>
                    💰 Açılma Tutarı: {formatTurkishCurrency(ak.tutar || 0)} ₺ | Tarih: {ak.acilisTarihi ? (ak.acilisTarihi instanceof Date ? ak.acilisTarihi.toLocaleDateString('tr-TR') : new Date(ak.acilisTarihi).toLocaleDateString('tr-TR')) : '-'}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* ID Kullanım Raporu */}
      <div style={{background: '#f7fafc', padding: '15px', borderRadius: '10px'}}>
        <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '15px'}}>📊 ID Kullanım Raporu</h3>
        {(() => {
          // V3.1: Hem aktif hem açılmış kumbaraların arşiv ID'lerini say
          const idKullanim = {};
          kumbaralar.forEach(k => {
            if (k.arsiv && Array.isArray(k.arsiv)) {
              k.arsiv.forEach(id => {
                idKullanim[id] = (idKullanim[id] || 0) + 1;
              });
            }
          });
          acilmisKumbaralar.forEach(ak => {
            if (ak.arsiv && Array.isArray(ak.arsiv)) {
              ak.arsiv.forEach(id => {
                idKullanim[id] = (idKullanim[id] || 0) + 1;
              });
            }
            // Açılmış kumbaranın kendi ID'sini de say
            if (ak.id) {
              idKullanim[ak.id] = (idKullanim[ak.id] || 0) + 1;
            }
          });
          const siraliIDler = Object.entries(idKullanim)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 20);

          return siraliIDler.length === 0 ? (
            <p style={{color: '#718096', textAlign: 'center', padding: '20px'}}>Henüz ID kullanım verisi yok</p>
          ) : (
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px'}}>
              {siraliIDler.map(([id, sayi]) => (
                <div key={id} style={{padding: '10px', background: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', textAlign: 'center'}}>
                  <div style={{fontWeight: 'bold', fontSize: '14px', color: '#2d3748'}}>ID: {id}</div>
                  <div style={{fontSize: '12px', color: '#718096', marginTop: '5px'}}>{sayi} kez kullanıldı</div>
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default ArsivSistemi;
